import { lazy } from "react";

const routes = [
  {
    path: "/delivery-point",
    element: lazy(() => import("../pages/Delivery_Point")),
  },
  {
    path: "/delivery-point/add",
    element: lazy(() => import("../pages/Delivery_Point/create-edit")),
  },
  // {
  //   exact: true,
  //   path: "/delivery-point/edit/:id",
  //   component: lazy(() => import("../pages/Delivery_Point/create-edit")),
  // },
  {
    path: "/delivery-point/edit/:id",
    element: lazy(() => import("../pages/Delivery_Point/create-edit")),
  },
];

export default routes;
